import axios from 'axios';

export const getInstances = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/servers`, settings);
}

export const getInstancesDetail = async (apiUrl, region, queryParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);

  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  if (queryParams) {
    return axios.get(`${apiUrl}/servers/detail${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/servers/detail`, settings);
  }
}

export const getInstanceDetails = async (apiUrl, instance_id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.get(`${apiUrl}/servers/${instance_id}`, settings);
}

export const deleteInstance = async (apiUrl, instance_id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/servers/${instance_id}`, settings);
}

export const createServer = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.post(`${apiUrl}/servers`, data, settings);
}

export const updateInstance = async (apiUrl, instanceId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.put(`${apiUrl}/servers/${instanceId}`, data, settings);
}

export const instanceAction = async (apiUrl, instanceId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.post(`${apiUrl}/servers/${instanceId}/action`, data, settings);
}

export const instanceConsole = async (apiUrl, instanceId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.post(`${apiUrl}/servers/${instanceId}/remote-consoles`, data, settings);
}

// ATTACHMENTS
export const attachVolume = async (apiUrl, instanceId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.post(`${apiUrl}/servers/${instanceId}/os-volume_attachments`, data, settings);
}

export const detachVolume = async (apiUrl, instanceId, volumeId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.delete(`${apiUrl}/servers/${instanceId}/os-volume_attachments/${volumeId}`, settings);
}

export const getInstanceVolumeAttachments = async (apiUrl, server) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === server.region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/servers/${server.id}/os-volume_attachments`, settings);
}

export const changeAttachVolume = async (apiUrl, instanceId, volumeId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'X-OpenStack-Nova-API-Version' : 'latest',
    }
  };

  return axios.put(`${apiUrl}/servers/${instanceId}/os-volume_attachments/${volumeId}`, data, settings);
}

// INTERFACES
export const getInterfaces = async (apiUrl, instanceId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/servers/${instanceId}/os-interface`, settings);
}

export const attachInstance = async (apiUrl, instanceId, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/servers/${instanceId}/os-interface`, data, settings);
}

export const detachInstance = async (apiUrl, instanceId, portId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/servers/${instanceId}/os-interface/${portId}`, settings);
}

export const getComputeQuota = async (apiUrl, region) => {
    let projectId = JSON.parse(localStorage.getItem('current_project'))[region];
    if (projectId == undefined) {
        if (region === 'core') {
            projectId = JSON.parse(localStorage.getItem('current_project')).ams2;
        } else if (region === 'stagingamstwo') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging102;
        } else if (region === 'stagingamsthree') {
            projectId = JSON.parse(localStorage.getItem('current_project')).staging101;
        }
    }
    let tokens = JSON.parse(localStorage.getItem('region_tokens'));
    let regionTokenData = tokens.find(item => item.name === region);
    const settings = {
        headers: {
            'X-Auth-Token': regionTokenData.token,
        }
    };
    return axios.get(`${apiUrl}/os-quota-sets/${projectId}/detail`, settings);
}

export const getComputeUsage = async (apiUrl) => {
  let osToken = localStorage.getItem('current_project_token');
  let projectId = localStorage.getItem('current_project');

  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/os-simple-tenant-usage/${projectId}`, settings);
}

export const getInstanceDiagnostics = async (apiUrl) => {
  let osToken = localStorage.getItem('current_project_token');
  let projectId = localStorage.getItem('current_project');

  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/v2/images?sort=name:asc`, settings);
}

export const getInstanceActions = async (apiUrl, server) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === server.region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/servers/${server.id}/os-instance-actions`, settings);
}